import * as React from "react";
const Pencil = (props) => (
  <svg
    width={17}
    height={18}
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.39193 17.3463C1.78193 17.3463 1.22193 17.1263 0.811925 16.7263C0.321925 16.2363 0.111925 15.5263 0.221925 14.7763L0.651925 11.7663C0.731925 11.1863 1.11193 10.4363 1.52193 10.0263L9.40193 2.14631C11.3919 0.156309 13.4119 0.156309 15.4019 2.14631C16.4919 3.23631 16.9819 4.34631 16.8819 5.45631C16.7919 6.35631 16.3119 7.23631 15.4019 8.13631L7.52193 16.0163C7.11193 16.4263 6.36193 16.8063 5.78193 16.8863L2.77193 17.3163C2.64193 17.3463 2.51193 17.3463 2.39193 17.3463ZM10.4619 3.20631L2.58192 11.0863C2.39192 11.2763 2.17192 11.7163 2.13192 11.9763L1.70193 14.9863C1.66193 15.2763 1.72193 15.5163 1.87193 15.6663C2.02193 15.8163 2.26193 15.8763 2.55193 15.8363L5.56193 15.4063C5.82193 15.3663 6.27193 15.1463 6.45193 14.9563L14.3319 7.07631C14.9819 6.42631 15.3219 5.84631 15.3719 5.30631C15.4319 4.65631 15.0919 3.96631 14.3319 3.19631C12.7319 1.59631 11.6319 2.04631 10.4619 3.20631Z"
      fill="#276AA6"
    />
    <path
      d="M13.7421 9.48603C13.6721 9.48603 13.6021 9.47603 13.5421 9.45603C10.9121 8.71603 8.82215 6.62603 8.08215 3.99603C7.97215 3.59603 8.20215 3.18603 8.60215 3.06603C9.00215 2.95603 9.41215 3.18603 9.52215 3.58603C10.1221 5.71603 11.8121 7.40603 13.9421 8.00603C14.3421 8.11603 14.5721 8.53603 14.4621 8.93603C14.3721 9.27603 14.0721 9.48603 13.7421 9.48603Z"
      fill="#276AA6"
    />
  </svg>
);
export default Pencil;
